import React from 'react';
import MuiSkeleton, {SkeletonProps} from '@mui/material/Skeleton';

const defaultSx = { backgroundColor: 'var(--background-quartary)' } as const;

export default function Skeleton(props: SkeletonProps) {
    const { sx, ...rest } = props;

    return (
        <MuiSkeleton
            {...rest}
            sx={{ ...defaultSx, ...(sx as any) }}
        />
    );
}
